import { render, staticRenderFns } from "./next_leve.vue?vue&type=template&id=742d2002&scoped=true&"
import script from "./next_leve.vue?vue&type=script&lang=js&"
export * from "./next_leve.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "742d2002",
  null
  
)

export default component.exports